import {
  apiClient,
  assertOk,
  jsonHeaders,
  responseText,
} from '@api/common'
import {
  type ExportFormat,
  type Grouping,
  type PlayerFilter,
} from '@constants/exports'
import {
  type ExportStartResponse,
  type ExportsHistoryResponse,
} from '@app-types/api/exports'

export interface StartExportPayload {
  games: string[]
  playerFilter: PlayerFilter
  exportFormat: ExportFormat
  grouping: Grouping
}

export async function fetchExportsHistory() {
  const response = await apiClient.get<ExportsHistoryResponse>(
    '/api/exports/history/',
  )

  assertOk(response, 'Не удалось загрузить историю выгрузок')

  return response.data
}

export async function startExport(
  values: StartExportPayload,
  csrfToken: string,
) {
  const response = await apiClient.post<ExportStartResponse>(
    '/api/exports/start/',
    {
      games: values.games,
      player_filter: values.playerFilter,
      export_format: values.exportFormat,
      grouping: values.grouping,
    },
    {
      headers: jsonHeaders(csrfToken),
    },
  )

  if (response.status < 200 || response.status >= 300) {
    const errorText = responseText(response)
    throw new Error(errorText || 'Не удалось запустить выгрузку')
  }

  return response.data
}
